<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Create Accounting Entry</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <CreateAccountingEntryForm />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../../router/layouts/main";
import PageHeader from "../../../components/AppComponents/page-header";
import CreateAccountingEntryForm from "../../../components/Kleyton/Forms/Product/AccountingEntry/CreateAccountingEntryForm";

export default {
  name: "CreateAccountingEntry",
  page: {
    title: "Create Accounting Entry",
    meta: [
      { name: "Create Accounting Entry", content: window.__env.app.description }
    ]
  },
  components: {
    CreateAccountingEntryForm,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "CreateAccountingEntry",
      title: "Create Accounting Entry",
      items: [
        {
          text: "Product",
          href: "/"
        },
        {
          text: "Create Accounting Entry",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
